/* ==========================================================================
   CENTRAL CANAP' — Couche de mouvement du site (assets/motion.js)
   Chargé sur toutes les pages, après global.js. JavaScript vanilla,
   encapsulé, sans dépendance. N'empêche jamais un clic, un lien, un
   formulaire ni la navigation : tout est amélioration progressive.

   1. Clic sur une carte produit : léger retour visuel sur la carte, puis
      navigation native immédiate (aucune transition entre pages).
   2. Cartes : apparition en cascade par rangée.
   3. Fiche produit : révélations variées des images éditoriales, prix
      animé au changement de variante, lightbox plus douce.
   4. Ajout au panier : image qui rejoint le panier + tiroir panier.
   5. Header : se retire en descendant, revient en remontant.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function $$(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function isModifiedClick(event) {
    return event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
  }

  /* ------------------------------------------------------------------------
     1. Clic sur une carte produit
     ------------------------------------------------------------------------ */
  function initCardClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var card = event.target.closest && event.target.closest('a.product-card');
        if (!card || isModifiedClick(event)) return;
        if (card.target && card.target !== '_self') return;

        card.classList.add('is-pressed');

        // Navigation native et immédiate : aucun fondu ni transition entre
        // pages (source de l'ancien « flash » avant la fiche produit).
      },
      true
    );

    // Retour arrière depuis le cache du navigateur : on remet tout en état.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      $$('.product-card.is-pressed').forEach(function (card) {
        card.classList.remove('is-pressed');
      });
    });
  }

  /* ------------------------------------------------------------------------
     2. Cartes : cascade par rangée
     ------------------------------------------------------------------------ */
  function initCards() {
    var cards = $$('a.product-card');
    if (!cards.length) return;

    if (reduceMotion) return;

    // Décalage de 70 ms entre cartes d'une même rangée (plafonné) : les
    // cartes arrivent en cascade, jamais toutes en même temps.
    var previousTop = null;
    var column = 0;
    cards.forEach(function (card) {
      if (!card.hasAttribute('data-reveal')) return;
      var top = Math.round(card.getBoundingClientRect().top);
      column = previousTop !== null && Math.abs(top - previousTop) < 8 ? column + 1 : 0;
      previousTop = top;
      var delay = Math.min(column, 4) * 70;
      if (!delay) return;
      card.style.transitionDelay = delay + 'ms';
      // Une fois apparue, la carte retrouve des survols instantanés.
      window.setTimeout(function () {
        var clear = function () {
          card.style.transitionDelay = '';
        };
        if (card.classList.contains('reveal-visible')) clear();
        else card.addEventListener('transitionend', clear, { once: true });
      }, 1200);
    });
  }

  /* ------------------------------------------------------------------------
     3. Fiche produit
     ------------------------------------------------------------------------ */
  function initProductPage() {
    if (!document.body.classList.contains('template-product')) return;

    // Prix : petit mouvement quand la variante le fait changer
    $$('[data-product-price]').forEach(function (price) {
      if (typeof MutationObserver === 'undefined' || reduceMotion) return;
      var last = price.textContent;
      new MutationObserver(function () {
        if (price.textContent === last) return;
        last = price.textContent;
        price.classList.remove('cc-flash');
        void price.offsetWidth;
        price.classList.add('cc-flash');
      }).observe(price, { childList: true, characterData: true, subtree: true });
    });

    // Lightbox : la nouvelle image arrive en fondu
    $$('[data-gallery-lightbox-image]').forEach(function (image) {
      if (typeof MutationObserver === 'undefined' || reduceMotion) return;
      new MutationObserver(function () {
        image.classList.remove('cc-swap');
        void image.offsetWidth;
        image.classList.add('cc-swap');
      }).observe(image, { attributes: true, attributeFilter: ['src'] });
    });

    // Images éditoriales des sections sous la fiche : trois façons
    // d'apparaître (masque, zoom, fondu) pour un rythme naturel.
    if (reduceMotion || typeof IntersectionObserver === 'undefined') return;

    var sections = $$('.cc-main > .shopify-section').slice(1);
    var kinds = ['mask', 'zoom', 'fade'];
    var candidates = [];
    sections.forEach(function (section) {
      $$('img', section).forEach(function (img) {
        if (img.closest('.product-card, .product-main, dialog, .pm-showroom, button')) return;
        if (img.getBoundingClientRect().width < 220) return;
        if (window.getComputedStyle(img).transform !== 'none') return;
        candidates.push(img);
      });
    });
    if (!candidates.length) return;

    root.classList.add('cc-motion');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -6% 0px' }
    );
    candidates.forEach(function (img, i) {
      var rect = img.getBoundingClientRect();
      img.classList.add('cc-img');
      img.setAttribute('data-cc-img', kinds[i % kinds.length]);
      // Déjà visible au chargement : pas d'effet, pas de saut.
      if (rect.top < window.innerHeight && rect.bottom > 0) img.classList.add('is-in');
      else observer.observe(img);
    });
  }

  /* ------------------------------------------------------------------------
     4. Ajout au panier : image vers le panier + tiroir
     ------------------------------------------------------------------------ */
  var moneyFormat = window.CentralCanapeMoneyFormat || '{{amount}} €';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    var noDecimals = withComma.replace(/,00$/, '');
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\w*\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\w*\s*\}\}/, withComma);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = null;
  var drawerTrigger = null;

  function buildDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('dialog');
    drawer.className = 'cc-drawer';
    drawer.setAttribute('aria-labelledby', 'CcDrawerTitle');
    drawer.setAttribute('scroll-lock', '');
    drawer.innerHTML =
      '<div class="cc-drawer__panel">' +
      '<div class="cc-drawer__head">' +
      '<p class="cc-drawer__title" id="CcDrawerTitle"><span class="cc-drawer__check" aria-hidden="true">' +
      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.5l3 3 6-7"/></svg>' +
      '</span>Ajouté au panier</p>' +
      '<button type="button" class="cc-drawer__close" data-cc-drawer-close aria-label="Fermer">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button>' +
      '</div>' +
      '<ul class="cc-drawer__items" role="list" data-cc-drawer-items></ul>' +
      '<div class="cc-drawer__foot">' +
      '<p class="cc-drawer__subtotal"><span>Sous-total</span><strong data-cc-drawer-subtotal></strong></p>' +
      '<p class="cc-drawer__note">Livraison et taxes éventuelles calculées lors de la commande.</p>' +
      '<a class="btn btn--accent btn--block" href="' + routesRoot + 'checkout">Commander</a>' +
      '<a class="btn btn--outline btn--block" href="' + routesRoot + 'cart">Voir le panier</a>' +
      '<button type="button" class="cc-drawer__continue" data-cc-drawer-close>Continuer mes achats</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(drawer);

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer || event.target.closest('[data-cc-drawer-close]')) drawer.close();
    });
    drawer.addEventListener('close', function () {
      if (drawerTrigger && document.contains(drawerTrigger)) {
        try {
          drawerTrigger.focus({ preventScroll: true });
        } catch (e) {
          drawerTrigger.focus();
        }
      }
    });
    return drawer;
  }

  function renderDrawer(cart) {
    var list = drawer.querySelector('[data-cc-drawer-items]');
    var subtotal = drawer.querySelector('[data-cc-drawer-subtotal]');
    var items = (cart.items || []).slice(0, 4);
    var html = items
      .map(function (item) {
        var image = item.image || '';
        var imgTag = image
          ? '<img src="' + escapeHtml(image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" loading="lazy" width="84" height="84">'
          : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return (
          '<li class="cc-drawer__item">' +
          '<a class="cc-drawer__thumb" href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true">' + imgTag + '</a>' +
          '<div>' +
          '<p class="cc-drawer__name"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></p>' +
          (variant ? '<p class="cc-drawer__meta">' + escapeHtml(variant) + '</p>' : '') +
          '<p class="cc-drawer__meta">Quantité : ' + item.quantity + '</p>' +
          '</div>' +
          '<span class="cc-drawer__price">' + escapeHtml(formatMoney(item.final_line_price)) + '</span>' +
          '</li>'
        );
      })
      .join('');
    var more = (cart.items || []).length - items.length;
    if (more > 0) {
      html += '<li><p class="cc-drawer__more">+ ' + more + ' autre' + (more > 1 ? 's' : '') + ' article' + (more > 1 ? 's' : '') + ' dans le panier</p></li>';
    }
    list.innerHTML = html;
    subtotal.textContent = formatMoney(cart.total_price);
  }

  function openDrawer(trigger) {
    if (typeof HTMLDialogElement === 'undefined') return;
    drawerTrigger = trigger || null;
    fetch(routesRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        buildDrawer();
        renderDrawer(cart);
        if (!drawer.open) drawer.showModal();
        var close = drawer.querySelector('.cc-drawer__close');
        if (close) {
          try {
            close.focus({ preventScroll: true });
          } catch (e) {
            close.focus();
          }
        }
      })
      .catch(function () {
        /* le toast et le compteur du thème restent le retour principal */
      });
  }

  function flyToCart(sourceImg) {
    return new Promise(function (resolve) {
      var target = document.querySelector('.site-header__cart');
      if (reduceMotion || !sourceImg || !target || typeof sourceImg.animate !== 'function') return resolve();

      var from = sourceImg.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      if (!from.width || from.bottom < 0 || from.top > window.innerHeight) return resolve();

      var size = Math.min(from.width, from.height, 220);
      var startX = from.left + from.width / 2 - size / 2;
      var startY = from.top + from.height / 2 - size / 2;
      var endX = to.left + to.width / 2 - size / 2;
      var endY = to.top + to.height / 2 - size / 2;

      var clone = document.createElement('img');
      clone.className = 'cc-fly';
      clone.src = sourceImg.currentSrc || sourceImg.src;
      clone.alt = '';
      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = startX + 'px';
      clone.style.top = startY + 'px';
      document.body.appendChild(clone);

      var dx = endX - startX;
      var dy = endY - startY;
      var animation = clone.animate(
        [
          { transform: 'translate(0, 0) scale(1)', opacity: 0.95 },
          { transform: 'translate(' + dx * 0.55 + 'px, ' + (dy * 0.55 - 40) + 'px) scale(0.45)', opacity: 0.9, offset: 0.6 },
          { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.1)', opacity: 0 }
        ],
        { duration: 720, easing: 'cubic-bezier(0.5, 0, 0.2, 1)', fill: 'forwards' }
      );
      var done = function () {
        clone.remove();
        resolve();
      };
      animation.onfinish = done;
      animation.oncancel = done;
      window.setTimeout(done, 1000);
    });
  }

  function initAddToCart() {
    if (typeof MutationObserver === 'undefined') return;
    $$('[data-add-to-cart]').forEach(function (button) {
      var wasAdded = button.classList.contains('is-added');
      new MutationObserver(function () {
        var added = button.classList.contains('is-added');
        if (added && !wasAdded) {
          var form = button.closest('form');
          var source =
            document.querySelector('.product-main__slide.is-active img') ||
            (form && form.closest('[class*="product"]') && form.closest('[class*="product"]').querySelector('img'));
          flyToCart(source).then(function () {
            openDrawer(button);
          });
        }
        wasAdded = added;
      }).observe(button, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ------------------------------------------------------------------------
     5. Header qui se retire / revient
     ------------------------------------------------------------------------ */
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header || reduceMotion) return;

    var lastY = window.pageYOffset;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.pageYOffset;
      var delta = y - lastY;
      var menuOpen = !!document.querySelector('dialog[open]');

      if (menuOpen || y < 140 || header.contains(document.activeElement)) {
        header.classList.remove('site-header--hidden');
      } else if (delta > 6 && y > 260) {
        header.classList.add('site-header--hidden');
      } else if (delta < -6) {
        header.classList.remove('site-header--hidden');
      }
      if (Math.abs(delta) > 6) lastY = y;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
    header.addEventListener('focusin', function () {
      header.classList.remove('site-header--hidden');
    });
  }

  /* ------------------------------------------------------------------------
     Démarrage
     ------------------------------------------------------------------------ */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initCardClicks();
    initCards();
    initProductPage();
    initAddToCart();
    initHeader();
  });
})();
